import React, { useState } from "react";
import { Row, Col, Table, Badge, Spinner, Form, Button } from "react-bootstrap";
import { remover_colaborador } from "../../../services/admin";

const UserSubscriptionStatus = ({ users, refresh }) => {
  const [filterRol, setFilterRol] = useState("all");
  const [filterEstado, setFilterEstado] = useState("all");
  const [sortBy, setSortBy] = useState(null);
  const [sortDir, setSortDir] = useState("asc");
  const [loadingUserId, setLoadingUserId] = useState(null);

  const handleChangeRol = async (user) => {
    setLoadingUserId(user._id);
    try {
      await remover_colaborador(user._id);
      await refresh();
    } finally {
      setLoadingUserId(null);
    }
  };

  const totalUsers = users.length;
  const activos = users.filter(
    (u) => u.estado_suscripcion === "ACTIVE" || u.estado_suscripcion === "PAID",
  ).length;
  const colaboradores = users.filter((u) => u.rol === "colaborador").length;
  const inactivos = totalUsers - activos;

  const roles = ["all", ...new Set(users.map((u) => u.rol))];
  const estados = ["all", ...new Set(users.map((u) => u.estado_suscripcion))];

  const handleSort = (col) => {
    if (sortBy === col) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(col);
      setSortDir("asc");
    }
  };

  const filteredData = users
    .filter((u) => filterRol === "all" || u.rol === filterRol)
    .filter(
      (u) => filterEstado === "all" || u.estado_suscripcion === filterEstado,
    )
    .sort((a, b) => {
      if (!sortBy) return 0;
      const valA = sortBy === "rol" ? a.rol : a.estado_suscripcion;
      const valB = sortBy === "rol" ? b.rol : b.estado_suscripcion;
      return sortDir === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

  return (
    <>
      {/* Summary */}
      <Row className="mb-4">
        <Col md={3}>
          <h5>Total usuarios</h5>
          <strong>{totalUsers}</strong>
        </Col>
        <Col md={3}>
          <h5>Colaboradores</h5>
          <strong>{colaboradores}</strong>
        </Col>
        <Col md={3}>
          <h5>Activos</h5>
          <strong>{activos}</strong>
        </Col>
        <Col md={3}>
          <h5>Inactivos</h5>
          <strong>{inactivos}</strong>
        </Col>
      </Row>

      {/* Filters */}
      <Row className="mb-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Filtrar por Rol</Form.Label>
            <Form.Select
              value={filterRol}
              onChange={(e) => setFilterRol(e.target.value)}
            >
              {roles.map((r) => (
                <option key={r} value={r}>
                  {r === "all" ? "Todos" : r}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group>
            <Form.Label>Filtrar por Estado</Form.Label>
            <Form.Select
              value={filterEstado}
              onChange={(e) => setFilterEstado(e.target.value)}
            >
              {estados.map((e) => (
                <option key={e} value={e}>
                  {e === "all" ? "Todos" : e}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {/* Table */}
      <Row>
        <Col xs={12}>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th
                  onClick={() => handleSort("rol")}
                  style={{ cursor: "pointer" }}
                >
                  Rol
                </th>
                <th
                  onClick={() => handleSort("estado")}
                  style={{ cursor: "pointer" }}
                >
                  Estado
                </th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((user) => (
                <tr key={user._id}>
                  <td>{user.nombre}</td>
                  <td>{user.correo}</td>

                  <td>
                    <Badge
                      bg={
                        user.rol === "admin" || user.rol === "colaborador"
                          ? "success"
                          : "secondary"
                      }
                    >
                      {user.rol}
                    </Badge>
                  </td>

                  <td>
                    <Badge
                      bg={
                        user.estado_suscripcion === "ACTIVE" ||
                        user.estado_suscripcion === "PAID"
                          ? "success"
                          : "danger"
                      }
                    >
                      {user.estado_suscripcion}
                    </Badge>
                  </td>

                  <td>
                    {user.rol === "colaborador" && (
                      <Button
                        size="sm"
                        variant="outline-warning"
                        disabled={loadingUserId === user._id}
                        onClick={() => handleChangeRol(user)}
                      >
                        {loadingUserId === user._id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Quitar colaborador"
                        )}
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default UserSubscriptionStatus;
